export enum CategoriesEnum {
    Supplies = 1,
    Printing = 2,
    Computing = 3,
    PPS = 4,
    DYP = 5
}